import React, { createRef } from 'react';

import ArrowSmallLeftIcon from '../assets/arrow-small-left-icon';
import ArrowSmallRightIcon from '../assets/arrow-small-right-icon';

const Slider = ({ contents, isArrowRounded, isShowIndicator, isRounded, imgClassnames }) => {
  const arrowStyles = isArrowRounded
    ? {
        left: (
          <div className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center">
            <ArrowSmallLeftIcon />
          </div>
        ),
        right: (
          <div className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center">
            <ArrowSmallRightIcon />
          </div>
        )
      }
    : {
        left: '❮',
        right: '❯'
      };

  const [currentImage, setCurrentImage] = React.useState(0);
  const refs = contents.reduce((acc, val, i) => {
    acc[i] = createRef();
    return acc;
  }, {});

  const scrollToImage = (i) => {
    setCurrentImage(i);
    refs[i].current.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  };

  const totalImages = contents.length;

  const nextImage = () => {
    if (currentImage >= totalImages - 1) {
      scrollToImage(0);
    } else {
      scrollToImage(currentImage + 1);
    }
  };

  const previousImage = () => {
    if (currentImage === 0) {
      scrollToImage(totalImages - 1);
    } else {
      scrollToImage(currentImage - 1);
    }
  };

  const arrowStyle = `absolute ${
    isArrowRounded && 'bottom-1/2'
  } text-white text-2xl z-10 h-10 w-10 rounded-full flex items-center justify-center`;

  const sliderControl = (isLeft) => (
    <button
      type="button"
      onClick={isLeft ? previousImage : nextImage}
      className={`${arrowStyle} ${isLeft ? 'left-2' : 'right-2'}`}
    >
      <span className="font-bold" role="img" aria-label={`Arrow ${isLeft ? 'left' : 'right'}`}>
        {isLeft ? arrowStyles.left : arrowStyles.right}
      </span>
    </button>
  );

  return (
    <div className="flex justify-center items-center">
      <div className="relative w-full">
        <div
          className={`inline-flex overflow-x-hidden w-full items-center ${
            isRounded && 'rounded-2xl'
          }`}
        >
          {totalImages > 1 && sliderControl(true)}
          {contents.map((content, i) => (
            <div className="w-full flex-shrink-0" key={content} ref={refs[i]}>
              <img src={content} className={`h-auto w-full object-center ${imgClassnames}`} alt="-" />
            </div>
          ))}
          {isShowIndicator && contents.length > 1 && (
            <div className="absolute z-30 flex space-x-3 -translate-x-1/2 bottom-5 left-1/2">
              {contents.map((_, idx) => (
                <span
                  key={idx}
                  className={`${
                    currentImage === idx ? 'bg-white' : 'bg-[#9E9E9E]'
                  } w-3 h-3 rounded-full`}
                />
              ))}
            </div>
          )}
          {totalImages > 1 && sliderControl()}
        </div>
      </div>
    </div>
  );
};

export default Slider;
